import { TextareaHTMLAttributes } from "react";

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  modContainerClassNames?: string;
  modTextAreaClassNames?: string;
}

const TextArea = ({
  label,
  modTextAreaClassNames,
  modContainerClassNames,
  ...props
}: Props) => (
  <div className={modContainerClassNames ? `${modContainerClassNames}` : ""}>
    <label className="mb-[0.4rem]">
      <p>{label}</p>
    </label>
    <textarea
      rows={6}
      className={`p-[1rem] text-[1.6rem] text-area border rounded-[0.5rem] mb-[2.4rem] focus:outline-none focus:ring-0 w-full ${
        modTextAreaClassNames ? modTextAreaClassNames : ""
      }`}
      {...props}
    />
  </div>
);

export default TextArea;
